








































































import {
  Component,
  PropSync,
  Prop,
  Watch,
  Vue
} from 'vue-property-decorator';
import { lbzfLockBodyScroll } from '../../utils/funcs';
import LbzIconButton from '../icon-button/icon-button.vue';
import LbzTopAppBar from '../top-app-bar/top-app-bar.vue';

@Component({
  components: {
    LbzIconButton,
    LbzTopAppBar
  }
})
export default class LbzDialog extends Vue {
  // [required]active.sync: true, false
  @PropSync('active', { type: Boolean, required: true })
  private cisActive!: boolean;

  // type: 'alert' (default), 'simple', 'confirmation', 'full-screen (mobile only)'
  @Prop({ type: String, default: '' }) private type!: string;
  // scrollable (type === 'confirmation'): true, false (default)
  @Prop({ type: Boolean, default: false }) private scrollable!: boolean;
  // stacked (['', 'alert', 'confirmation'].includes(type)): true, false (default)
  @Prop({ type: Boolean, default: false }) private stacked!: boolean;
  // title: '' (default), 'x'
  @Prop({ type: String, default: '' }) private title!: string;
  // height (type !== 'full-screen'): '' (default), 'x'
  @Prop({ type: String, default: '' }) private height!: string;
  // append-to-body: true, false (default)
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean;
  // lock-body-scroll: true (default), false
  @Prop({ type: Boolean, default: true }) private lockBodyScroll!: boolean;

  get cisAlertAndConfirmation(): boolean {
    return ['', 'alert', 'confirmation'].includes(this.type);
  }

  @Watch('cisActive')
  private factiveChanged(val: boolean): void {
    this.$emit(val ? 'open' : 'close');

    if (this.lockBodyScroll) {
      lbzfLockBodyScroll(val);
    }
  }

  private mounted(): void {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  }

  private ftoggle(): void {
    this.cisActive = !this.cisActive;
  }

  private fopen(): void {
    this.cisActive = true;
  }

  private fclose(): void {
    this.cisActive = false;
  }
}
